(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rose-hero"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-rh]').forEach(function(el){if(el.dataset.ready)return;el.dataset.ready=1;var s=[].slice.call(el.querySelectorAll('.rh__slide')),d=[].slice.call(el.querySelectorAll('.rh__dot')),i=0,t;function go(n){i=(n+s.length)%s.length;s.forEach(function(x,k){x.classList.toggle('is-on',k===i)});d.forEach(function(x,k){x.classList.toggle('is-on',k===i)})}function run(){clearInterval(t);if(s.length>1&&!matchMedia('(prefers-reduced-motion:reduce)').matches)t=setInterval(function(){go(i+1)},+el.dataset.interval||5000)}d.forEach(function(x,k){x.addEventListener('click',function(){go(k);run()})});run()});

  } catch(e) { console.error(e); }
})();
})();
